import { graphql, PageRendererProps } from 'gatsby';
import React from 'react';
import styled from 'styled-components';
import {
  AirtableRemoteWorkAuthors,
  AirtableRemoteWorkAuthorsData,
  AirtableRemoteWorkAuthorsEdge,
  AuthorByIdQuery,
} from '../../graphql-types';
import { AuthorForm, AuthorHero, Publications } from '../components/Author';
import { Layout, Section } from '../components/Layout';
import SEO from '../components/SEO';
import { floralwhite } from '../utils/styles';
import { rhythm } from '../utils/typography';

interface Props extends PageRendererProps {
  pageContext: AirtableRemoteWorkAuthorsEdge;
  data: AuthorByIdQuery;
}

const PublicationsContainer = styled(Section)`
  margin-top: ${rhythm(1)};
  padding-top: ${rhythm(1.5)};
`;

const AuthorTemplate = ({ data }: Props) => {
  const { name, jobTitle, publications, firstName, questionsGoal } = data.author?.data || {};

  const withTakeaways = publications?.filter(publication => !!publication?.data?.takeaways?.length);
  const withoutTakeaways = publications?.filter(publication => !publication?.data?.takeaways?.length);

  return (
    <Layout>
      <SEO title={name!} description={jobTitle!} />
      <AuthorHero author={data.author} />
      <PublicationsContainer color={floralwhite}>
        {withTakeaways && <Publications list={withTakeaways as AirtableRemoteWorkAuthorsData['publications']} />}
        {withoutTakeaways && <Publications list={withoutTakeaways as AirtableRemoteWorkAuthorsData['publications']} />}
      </PublicationsContainer>
      <Section color={floralwhite}>
        <AuthorForm
          title={`Any question? Ask ${firstName} anything.`}
          subtitle={`We are collecting ${questionsGoal} questions for ${firstName}. Post yours!`}
          author={data.author as AirtableRemoteWorkAuthors}
        />
      </Section>
    </Layout>
  );
};

export default AuthorTemplate;

export const pageQuery = graphql`
  query AuthorById($id: String!) {
    author: airtableRemoteWorkAuthors(id: { eq: $id }) {
      id
      recordId
      data {
        name
        firstName
        jobTitle
        slug
        twitter
        questionsGoal
        jobOpenings
        picture {
          localFiles {
            childImageSharp {
              fluid(maxWidth: 160) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        publications {
          data {
            name
            publishDate(formatString: "MMMM YYYY")
            description
            takeaways
            url
          }
          id
          recordId
        }
      }
    }
  }
`;
